import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { 
  categoriesList, 
  bannerSlides, 
  subBanners, 
  homeSecuritySection, 
  architectureSection, 
  electricalSection, 
  appliancesSection 
} from '../../pages/Home/homeData';
import { dbProducts } from '../../data/db';

const getProducts = (category: string) => {
  return dbProducts.products.filter(p => p.category === category).slice(0, 10).map(p => ({
    id: p.id,
    name: p.name,
    brand: p.brand,
    rating: parseFloat(p.rating),
    reviewsCount: p.reviewsCount,
    price: p.price,
    oldPrice: p.oldPrice,
    discount: p.discount,
    isDeal: p.isDeal,
    image: p.image
  }));
};

interface CMSState {
  home: {
    categoriesList: typeof categoriesList;
    bannerSlides: typeof bannerSlides;
    subBanners: typeof subBanners;
    homeSecuritySection: typeof homeSecuritySection;
    architectureSection: typeof architectureSection;
    electricalSection: typeof electricalSection;
    appliancesSection: typeof appliancesSection;
  };
  navigation: {
    logo: string;
    contactNumber: string;
    email: string;
  };
  // Add more sections as needed
}

const initialState: CMSState = {
  home: {
    categoriesList,
    bannerSlides,
    subBanners,
    homeSecuritySection: {
      ...homeSecuritySection,
      products: getProducts('Home Security')
    },
    architectureSection: {
      ...architectureSection,
      products: getProducts('Lighting')
    },
    electricalSection: {
      ...electricalSection,
      products: getProducts('Electricals')
    },
    appliancesSection: {
      ...appliancesSection,
      products: getProducts('Appliances')
    },
  },
  navigation: {
    logo: '/assets/images/headerlogo.png',
    contactNumber: '+91-9999039039',
    email: 'care@industrybull.com',
  },
};

const cmsSlice = createSlice({
  name: 'cms',
  initialState,
  reducers: {
    updateHomeSection: (state, action: PayloadAction<{ section: keyof CMSState['home']; data: any }>) => {
      state.home[action.payload.section] = action.payload.data;
    },
    updateNavigation: (state, action: PayloadAction<Partial<CMSState['navigation']>>) => {
      state.navigation = { ...state.navigation, ...action.payload };
    },
    // Generic update for deeply nested fields if needed
    updateCMSField: (state, action: PayloadAction<{ path: string; value: any }>) => {
      // Logic to update state by path (string like 'home.bannerSlides[0].title')
      // For simplicity, we'll use specific actions first
    }
  },
});

export const { updateHomeSection, updateNavigation } = cmsSlice.actions;
export default cmsSlice.reducer;
